module.exports = __webpack_public_path__ + "assets/img/07e8567de1ed9bdcb393de6b4098b775.svg";